import React                    from 'react';
import { connect }              from 'react-redux';
import BusinessReviews          from '../components/BusinessReviews';
import BusinessControl          from '../components/BusinessControl';
import { ymElem }               from '../utils/helpers';
import BusinessControlTabs      from '../components/BusinessControlTabs';
import { trackEvent }                       from '../utils/tracking'

class Business extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { lang } = this.props;

        return (
            <div key="Business" className="page page-business">
                <div className="s-business-start">
                    <div className="bg-2" />
                    <div className="bg-1" />
                    <div className="container">
                        <h2 className="s-index__title t-left">{lang.BusIntro1} <span className="color">{lang.BusIntro2}</span></h2>
                        <p className="business-start__desc">{lang.BusIntro3}</p>

                        <div className="business-start-form">
							<button type="button" className="btn btn-primary" onClick={() => trackEvent('business_form', this.props.openbussiness)}>{lang.BusConnect}</button>
							{/*<div className="index-callback-form">
                                <form action="/" method="post" className="form row">
                                    <div className="form-group col-8">
                                        <input type="text" className="form-control" placeholder={lang.Index_callback_1_placeholder}/>
                                    </div>
                                    <div className="form-group col-4">
                                        <button type="submit" disabled="disabled" className="btn btn-block btn-primary">{lang.Index_callback_1_btn}</button>
                                    </div>
                                </form>
                                <div className="hint-form">Дарим <span className="color">3000 ₽</span> на тестовую неделю</div>
                            </div>*/}
                        </div>

                        <div className="business-start-adv">
                            <div className="row">
                                <div className="business-start-adv-item t-1 col">
                                    <div className="img">
										<div className="img-icon insurance"/>
                                    </div>
                                    <div className="cnt">
                                        <h3 className="title">{lang.BusTit1}</h3>
                                        <p className="desc">{lang.BusTitText1}</p>
                                    </div>
                                </div>

                                <div className="business-start-adv-item t-2 col">
                                    <div className="img">
										<div className="img-icon done_list"/>
                                    </div>
                                    <div className="cnt">
                                        <h3 className="title">{lang.BusTit2}</h3>
                                        <p className="desc">{lang.BusTitText2}</p>
                                    </div>
                                </div>

                                <div className="business-start-adv-item t-3 col">
                                    <div className="img">
										<div className="img-icon wallet"/>
                                    </div>
                                    <div className="cnt">
                                        <h3 className="title">{lang.BusTit3}</h3>
                                        <p className="desc">{lang.BusTitText3}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<div className="business-start-btn">
							<button type="button" className="btn btn-primary">Создать заказ</button>
						</div>*/}

                        <div className="index-delivery-partners">
                            <span className="label">{lang.Index_start_2_partners_title}</span>
                            <ul className="index-delivery-partners-list list-unstyled">
                                <li>
									<div className="img-icon bacardi"/>
                                </li>
                                <li>
									<div className="img-icon michelin"/>
                                </li>
                                <li>
									<div className="img-icon coca_cola"/>
                                </li>
                                <li>
									<div className="img-icon mtc"/>
                                </li>
                                <li>
									<div className="img-icon fifa"/>
                                </li>
                                <li>
									<div className="img-icon myz"/>
                                </li>
                                <li>
									<div className="img-icon moscow"/>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="s-business-path">
                    <div className="container">
                        <h2 className="s-index__title t-right">{lang.BusSec1}</h2>
                        <p className="business-path__desc">{lang.BusSec2}</p>
                        <div className="business-path-img">
							<div className="img-icon"/>
                        </div>
                    </div>
                </div>

                <BusinessReviews lang={lang} />

                <div className="s-index-adv s-index">
                    <div className="container">
                        <div className="index-adv row">
                            <div className="index-adv-item t-1 col">
                                <div className="img">
									<div className="img-icon money"/>
                                </div>
                                <div className="cnt">
                                    <h3 className="title">{lang.Index_adv_title_1}</h3>
                                    <p className="desc">{lang.Index_adv_desc_1}</p>
                                </div>
                            </div>

                            <div className="index-adv-item t-2 col">
                                <div className="img">
									<div className="img-icon winner"/>
                                </div>
                                <div className="cnt">
                                    <h3 className="title">{lang.Index_adv_title_2}</h3>
                                    <p className="desc">{lang.Index_adv_desc_2}</p>
                                </div>
                            </div>

                            <div className="index-adv-item t-3 col">
                                <div className="img">
									<div className="img-icon ui"/>
                                </div>
                                <div className="cnt">
                                    <h3 className="title">{lang.Index_adv_title_3}</h3>
                                    <p className="desc">{lang.Index_adv_desc_3}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <BusinessControl openbussiness={this.props.openbussiness} lang={lang} />

                <div className="s-business-decision">
                    <div className="container">
                        <h2 className="s-index__title">{lang.Bus2_1} <span className="color">{lang.Bus2_2}</span> {lang.Bus2_3}</h2>
                        <p className="business-decision__desc">{lang.Bus2Intro}</p>

                        <div className="business-decision-list">
                            <div className="row">
                                <div className="col-6">
                                    <div className="business-decision-item">
                                        <h3 className="title">{lang.Bus3_1}</h3>
                                        <p className="desc">{lang.Bus3_1Intro}</p>
                                        <ul className="list-unstyled type-list">
                                            <li className="t-1">
                                                <i className="icon"/>
                                                {lang.BusCarType1}
                                            </li>
                                            <li className="t-2">
                                                <i className="icon"/>
                                                {lang.BusCarType2}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="business-decision-item">
                                        <h3 className="title">{lang.Bus3_2}</h3>
                                        <p className="desc">{lang.Bus3_2Intro}</p>
                                        <ul className="list-unstyled type-list">
                                            <li className="t-1">
                                                <i className="icon"/>
                                                {lang.BusCarType1}
                                            </li>
                                            <li className="t-2">
                                                <i className="icon"/>
                                                {lang.BusCarType2}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="business-decision-item">
                                        <h3 className="title">{lang.Bus3_3}</h3>
                                        <p className="desc">{lang.Bus3_3Intro}</p>
                                        <ul className="list-unstyled type-list">
                                            <li className="t-1">
                                                <i className="icon"/>
                                                {lang.BusCarType1}
                                            </li>
                                            <li className="t-2">
                                                <i className="icon"/>
                                                {lang.BusCarType2}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="business-decision-item">
                                        <h3 className="title">{lang.Bus3_4}</h3>
                                        <p className="desc">{lang.Bus3_4Intro}</p>
                                        <ul className="list-unstyled type-list">
                                            <li className="t-1">
                                                <i className="icon"/>
                                                {lang.BusCarType1}
                                            </li>
                                            <li className="t-2">
                                                <i className="icon"/>
                                                {lang.BusCarType2}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

						{/*<div className="business-decision-more">
                            <a href="#" className="link">{lang.BusPrivate}</a>
                        </div>*/}
                    </div>
                </div>

                <BusinessControlTabs lang={lang}/>

                <div className="s-business-category">
                    <div className="container">
                        <h2 className="s-index__title">{lang.BussBlock3Title}<span className="color">{lang.BussBlock3Title2}</span></h2>
                        <p className="business-category__desc">{lang.BussBlock3Intro}</p>

                        <div className="business-category-list">
                            <div className="row">
                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🛒</div>
                                        <h3 className="title">{lang.BussItem1}</h3>
                                        <div className="count">43 {lang.BussComp1}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🚗</div>
                                        <h3 className="title">{lang.BussItem2}</h3>
                                        <div className="count">15 {lang.BussComp2}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🛍</div>
                                        <h3 className="title">{lang.BussItem3}</h3>
                                        <div className="count">53 {lang.BussComp3}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🏗</div>
                                        <h3 className="title">{lang.BussItem4}</h3>
                                        <div className="count">65 {lang.BussComp3}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🚚</div>
                                        <h3 className="title">{lang.BussItem5}</h3>
                                        <div className="count">27 {lang.BussComp2}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🎸</div>
                                        <h3 className="title">{lang.BussItem6}</h3>
                                        <div className="count">11 {lang.BussComp4}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🎊</div>
                                        <h3 className="title">{lang.BussItem7}</h3>
                                        <div className="count">25 {lang.BussComp3}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">📦</div>
                                        <h3 className="title">{lang.BussItem8}</h3>
                                        <div className="count">9 {lang.BussComp2}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🐴</div>
                                        <h3 className="title">{lang.BussItem9}</h3>
                                        <div className="count">19 {lang.BussComp2}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🍅</div>
                                        <h3 className="title">{lang.BussItem10}</h3>
                                        <div className="count">11 {lang.BussComp2}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🛒</div>
                                        <h3 className="title">{lang.BussItem11}</h3>
                                        <div className="count">13 {lang.BussComp2}</div>
                                    </div>
                                </div>

                                <div className="col-4">
                                    <div className="business-category-item">
                                        <div className="img">🛒</div>
                                        <h3 className="title">{lang.BussItem12}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="s-business-comparison">
                    <div className="container">
                        <h2 className="s-index__title">{lang.BussBlock4Title}</h2>
                        <p className="business-comparison__desc">{lang.BussBlock4Intro}</p>

                        <div className="business-comparison-table">
                            <div className="table-wrapper">
                                <div className="table-row t-th">
                                    <div className="table-th">{lang.BussBlock4Column1}</div>
                                    <div className="table-th">{lang.BussBlock4Column2}</div>
                                    <div className="table-th">
										<div className="img-icon brand"/>
                                    </div>
                                </div>
                                <div className="table-row">
                                    <div className="table-td">
                                        <div className="desc">
                                            <div className="img">🚚</div>
                                            {lang.BussBlock4Row1}
                                        </div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">50</div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">1000 +</div>
                                    </div>
                                </div>

                                <div className="table-row">
                                    <div className="table-td">
                                        <div className="desc">
                                            <div className="img">☔</div>
                                            {lang.BussBlock4Row2}
                                        </div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">
											<div className="img-icon cancel"/>
                                        </div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">
											<div className="img-icon done"/>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-row">
                                    <div className="table-td">
                                        <div className="desc">
                                            <div className="img">💵</div>
                                            {lang.BussBlock4Row3}
                                        </div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">1500 ₽</div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">890 ₽</div>
                                    </div>
                                </div>

                                <div className="table-row">
                                    <div className="table-td">
                                        <div className="desc">
                                            <div className="img">📑</div>
                                            {lang.BussBlock4Row4}
                                        </div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">{lang.BussBlock4Ph1}</div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">{lang.BussBlock4Ph2}</div>
                                    </div>
                                </div>

                                <div className="table-row">
                                    <div className="table-td">
                                        <div className="desc">
                                            <div className="img">⏱</div>
                                            {lang.BussBlock4Row5}
                                        </div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">2 {lang.TariffCountH}</div>
                                    </div>
                                    <div className="table-td">
                                        <div className="size">30 {lang.TariffCountM2}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="s-business-terminal">
                    <div className="container">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="s-index__title t-left">{lang.BussBlock5Title}</h2>
                                <p className="business-terminal__desc">{lang.BussBlock5Intro}</p>
                                <div className="business-terminal-adv">
                                    <div className="row">
                                        <div className="business-terminal-adv-item t-1 col">
                                            <div className="img">
												<div className="img-icon tarrifs"/>
                                            </div>
                                            <div className="cnt">
                                                <h3 className="title">{lang.BusinessMain5_1}</h3>
                                                <p className="desc">{lang.BusinessMain5_1Intro}</p>
                                            </div>
                                        </div>

                                        <div className="business-terminal-adv-item t-2 col">
                                            <div className="img">
												<div className="img-icon timer"/>
                                            </div>
                                            <div className="cnt">
                                                <h3 className="title">{lang.BusinessMain5_2}</h3>
                                                <p className="desc">{lang.BusinessMain5_2Intro}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="business-terminal-btn">
                                    <button type="button" className="btn btn-primary" onClick={() => trackEvent('business_form', this.props.openbussiness)}>{lang.Index_business_more_btn}</button>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="business-terminal-img"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="s-business-banner">
                    <div className="container">
                        <div className="row">
                            <div className="col-7">
                                <h2 className="s-index__title t-white t-left">{lang.BussBlock6Title}</h2>
                                <p className="business-banner__desc">{lang.BussBlock6Intro}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapState = state => ({
    lang: state.lang
});

export default connect(mapState)(Business);

// @ToDo - Вынести блоки бизнес страницы в отдельные компоненты
